export const TEST_ID = 'partSerialNumberField';
